import React, { useState, useEffect }  from 'react';
import PropTypes from 'prop-types';
import autoload from '../../helpers/autoload';
import axios from 'axios';

import NavTile from './NavTile';

// Fetches a Program from the API based on the path (matches Program.label)
// and renders any direct children of that Program as NavTile(s)
const NavTiles = ({ path }) => {
  const PROGRAMS_PATH = '/api/v1/programs/search';

  const [children, setChildren] = useState([]);

  useEffect(() => {
    const fetchPrograms = async () => {
      try {
        const response = await axios.get(`${PROGRAMS_PATH}?q=${path}`);
        let programs = response.data.data.programs || [];

        // Programs API does a ransack on Program.label_contains
        if (programs.length > 1) {
          // If there's an exact match by label, use only that one
          const exactMatch = programs.find(program => program.label.toLowerCase() === path.toLowerCase());
          if (exactMatch) {
            programs = [exactMatch];
          } else {
            throw new Error(`The path "${path}" returns multiple programs. Please provide a more specific path.`);
          }
        }

        if (programs.length === 0) {
          throw new Error(`No programs found for the path "${path}".`);
        }

        let program = programs[0];
        setChildren(program.children || []);
      } catch (error) {
        console.error('Error fetching programs from API:', error);
        setChildren([]);
      }
    };
    fetchPrograms();
  }, [path]);

  return (
    <div className="nav-points">
      <div className='tile-group'>
        {children.map((program) => (
          <NavTile
            key={program.id}
            tile={{
              label: program.label,
              description: program.description,
              imageURL: program.image_url,
              linkURL: program.link_url,
              children: program.children,
            }}
          />
        ))}
      </div>
    </div>
  );
};

NavTiles.propTypes = {
  path: PropTypes.string.isRequired,
};

export default autoload(NavTiles, 'nav-tiles')